/**
 * Enumeration for sort directions.
 *
 * @interface
 */
export enum Direction {
  ASC = "asc",
  DESC = "desc"
}
